export default [
  {
    action: `read`,
    subject: `dashboard`
  }
];
